import { render, staticRenderFns } from "./author.vue?vue&type=template&id=aa073e14&scoped=true&"
import script from "./author.vue?vue&type=script&lang=js&"
export * from "./author.vue?vue&type=script&lang=js&"
import style0 from "./author.vue?vue&type=style&index=0&id=aa073e14&prod&lang=scss&"
import style1 from "./author.vue?vue&type=style&index=1&id=aa073e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa073e14",
  null
  
)

export default component.exports